module.exports = __webpack_public_path__ + "img/fz_tpzb.1cc04be9.png";